import { supabase } from './supabase';

const normalizeWorkerUrl = (value: unknown): string | null => {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (trimmed.length === 0) return null;
  return trimmed.replace(/\/+$/, '');
};

export const forgeWorkerUrl = normalizeWorkerUrl(import.meta.env.VITE_FORGE_WORKER_URL);

const parseJsonOrText = async (response: Response): Promise<unknown> => {
  const text = await response.text();
  if (text.trim().length === 0) return null;

  try {
    return JSON.parse(text) as unknown;
  } catch {
    return text;
  }
};

const extractErrorMessage = (payload: unknown, fallback: string): string => {
  if (typeof payload === 'string' && payload.trim().length > 0) return payload;
  if (typeof payload !== 'object' || payload === null) return fallback;

  const record = payload as Record<string, unknown>;
  const error = record.error;
  if (typeof error === 'string' && error.trim().length > 0) return error;
  if (typeof error === 'object' && error !== null && 'message' in error) {
    const message = (error as { message: unknown }).message;
    if (typeof message === 'string' && message.trim().length > 0) return message;
  }

  return fallback;
};

export const invokeForgeWorker = async (body: unknown): Promise<unknown> => {
  if (!forgeWorkerUrl) {
    throw new Error('Forge worker URL is not configured.');
  }

  const { data: { session } } = await supabase.auth.getSession();
  const accessToken = session?.access_token;
  if (!accessToken) {
    throw new Error('Session expirée. Reconnecte-toi.');
  }

  const response = await fetch(forgeWorkerUrl, {
    method: 'POST',
    headers: {
      authorization: `Bearer ${accessToken}`,
      'content-type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  const payload = await parseJsonOrText(response);
  if (!response.ok) {
    throw new Error(extractErrorMessage(payload, `HTTP ${response.status}`));
  }

  return payload;
};
